import { atom } from 'jotai';

export const globalSearchOpenAtom = atom(false);
